__turbopack_context__.v({
  "column": "Credits-module-scss-module__2CJh9q__column",
  "creditsHeart": "Credits-module-scss-module__2CJh9q__creditsHeart",
  "row": "Credits-module-scss-module__2CJh9q__row",
  "wrapper": "Credits-module-scss-module__2CJh9q__wrapper",
});
